import { useEffect } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

// If there was a promo code submitted and it is valid, need to set it as formik value

const useUpdateCoupon = (): void => {
  const {
    values: { [OrderFields.PROMO_CODE]: currentPromoCode },
    setFieldValue,
  } = useOrderFormik();

  const {
    dynamicData: { coupon },
  } = useOrderData();

  useEffect(() => {
    if (currentPromoCode || !coupon || !coupon?.isValid) {
      // Previous coupon is still set or no new coupon was submitted
      return;
    }

    setFieldValue(OrderFields.PROMO_CODE, coupon.promoCode);
  }, [coupon, currentPromoCode, setFieldValue]);
};
export default useUpdateCoupon;
